import { useEffect } from 'react'

import { AcquiringItem, RefillType } from 'app/dataTypes/acquiring/settings'
import { StatusMessage } from 'app/common/templates-next/page-template'
import { BankCardId } from 'app/dataTypes/acquiring/recurrent/cards'

import Order from './Order'

type Props = {
  acquiringItem: AcquiringItem | null
  amount: string
  refillType: RefillType | null
  successURL: string
  failureURL: string
  recurrent: { bankId: BankCardId } | { save: boolean } | {} | null
  onPrev: () => void
}

const Step5 = ({
  acquiringItem,
  amount,
  refillType,
  successURL,
  failureURL,
  recurrent,
  onPrev,
}: Props) => {
  const amountFloat = parseFloat(amount)

  useEffect(() => {
    if (Number.isNaN(amountFloat)) {
      onPrev()
    }
  }, [amountFloat]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!acquiringItem || refillType === null || recurrent === null) {
    return (
      <StatusMessage
        comment="Отсутствуют данные эквайринга или тип пополнения. Вернитесь к первому шагу и попробуйте снова"
        skipPadding
      >
        {'Произошла непредвиденная ошибка'}
      </StatusMessage>
    )
  }

  if (Number.isNaN(amountFloat)) {
    return null
  }

  return (
    <Order
      recurrent={recurrent}
      acquiringItem={acquiringItem}
      amount={amountFloat}
      refillType={refillType}
      successURL={successURL}
      failureURL={failureURL}
    />
  )
}

export default Step5
